let store = {};
let callback = null;

export default function recaptchaLoader(vuexStore, aCallback = null) {
    store = vuexStore;
    callback = aCallback;

    if (!store.state.recaptcha.isReady && !store.state.recaptcha.isLoading) {
        store.dispatch('recaptcha/setLoading');

        const scriptTag = document.createElement('script');
        const firstScriptTag = document.getElementsByTagName('script')[0];

        scriptTag.src = 'https://www.google.com/recaptcha/api.js?render=explicit&onload=initializeRecaptcha';
        firstScriptTag.parentNode.insertBefore(scriptTag, firstScriptTag);
    }
}

if (process.client) {
    window.initializeRecaptcha = () => {
        store.dispatch('recaptcha/setReady');
        if (typeof callback === 'function') {
            callback();
        }
    };
}
